import { cn } from './chunk-FFX3LZW7.js';
import { cva } from 'class-variance-authority';
import { jsx } from 'react/jsx-runtime';

var badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus-ring",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        brand: "border-transparent bg-brand text-brand-foreground",
        // Interface state, as a tinted chip — the form every status pill in
        // the product already took when it was hand-written in raw amber /
        // emerald / sky. For a solid fill use `bg-<state> text-<state>-foreground`.
        warning: "border-warning/40 bg-warning/10 text-warning",
        success: "border-success/40 bg-success/10 text-success",
        info: "border-info/40 bg-info/10 text-info"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
function Badge({ className, variant, ...props }) {
  return /* @__PURE__ */ jsx("div", { className: cn(badgeVariants({ variant }), className), ...props });
}

export { Badge, badgeVariants };
//# sourceMappingURL=chunk-2WDEGOCV.js.map
//# sourceMappingURL=chunk-2WDEGOCV.js.map